import Vue from 'vue';

let swalInstance = null;

async function getSwal() {
    if (!swalInstance) {
        const Swal = (await import(/* webpackChunkName: "sweetalert" */ 'sweetalert2')).default;
        await import(/* webpackChunkName: "sweetalert-css" */ 'sweetalert2/dist/sweetalert2.min.css');
        swalInstance = Swal;
    }
    return swalInstance;
}

const swalProxy = function(...args) {
    return getSwal().then(Swal => Swal.fire(...args));
};

swalProxy.fire = function(...args) {
    return getSwal().then(Swal => Swal.fire(...args));
};

Vue.prototype.$swal = swalProxy;

export default swalProxy;
